import { type CoreBundleItem, type CoreBundle } from '@flecto/types'
import { DataTable, type DataTableProps } from '@flecto/ui'

import { useColumns } from './useColumns'

type TableBundlesProps = Omit<
  DataTableProps<CoreBundle | CoreBundleItem>,
  'columns'
> & {
  bundles?: Array<CoreBundle | CoreBundleItem>
  isLoading?: boolean
}

export function TableBundles({ bundles, isLoading, ...props }: TableBundlesProps) {
  const columns = useColumns()

  return (
    <DataTable
      {...props}
      records={bundles}
      columns={columns}
      isLoading={isLoading}
      highlightOnHover
      groupCollapsible={true}
      rowStyle={(row) =>
        'item_type' in row && row.item_type === 'bundle'
          ? { backgroundColor: 'white' }
          : { backgroundColor: 'var(--mantine-color-gray-0)' }
      }
    />
  )
}
